module.exports = __webpack_public_path__ + "static/media/bin.db87090e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/utils/images/bin.svg
// module id = 123
// module chunks = 1